module.exports = __webpack_public_path__ + "Icono_Descargar.png";